import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import base from '../../base.styl';
import styles from './TopSection.styl';
import Button from '../button/Button';

class TopSection extends React.Component {
  constructor(props) {
    super(props);
  }
  scrollTop = () => {
    window.scrollTo(0, 0);
    let zi = document.getElementById('zip-input');
    if(zi) zi.focus();
  }
  render() {
    return (
      <Grid fluid className={base.container}>
        <Row middle="xs">
          <Col xs={12} sm={7} className={styles.info}>
            <p className={styles.hashtag}>#ONEACTFORALL</p>
            <h1 className={styles.headline}>save the esa</h1>
            <p className={styles.infoParagraph}>
              The U.S. Endangered Species Act (“ESA”) is one of the world’s most
              indispensable environmental laws, essential to saving imperiled
              wildlife across the globe. But despite the ESA’s undeniable success
              in protecting wildlife and ecosystems in the U.S. and abroad, some
              powerful members of Congress and special interest groups are trying
              to dismantle the law. We need your help to save this landmark Act
              before it’s too late.
            </p>

            <Button title="Act Now" color="#003973" scrollTop={this.scrollTop} />
          </Col>
          <Col xs={12} sm={5} className={styles.image}>
            <img src="https://s3-us-west-2.amazonaws.com/ifaw-congress/Save-the-ESA.jpg" alt="" />
          </Col>
        </Row>
      </Grid>
    );
  }
}


export default TopSection;



// WEBPACK FOOTER //
// ./src/components/static/TopSection.js